import { OnDestroy, Directive } from '@angular/core';
import {
  IAdvancedFormConfig,
  IAdvancedFormContainer,
  IAdvancedFormEvent,
  AdvancedFormEventTypes,
} from '~shared/modules/advanced-form/models/advanced-form.model';

import { AuthorizationService } from '../services/authorization.service';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { Subject } from 'rxjs';

@Directive()
export abstract class AuthorizationFormClassDirective implements IAdvancedFormContainer, OnDestroy {
  public advancedFormConfig: IAdvancedFormConfig;
  public isAuthTrackEnabled = false;
  unsubscribe$ = new Subject();

  constructor(
    protected authorizationService: AuthorizationService,
    protected activeFeaturesConfigcatService: ActiveFeaturesConfigcatService,
    protected applicationEventService: ApplicationEventService
  ) {}

  public onAdvancedFormEvents(event: IAdvancedFormEvent): void {
    if (event.type === AdvancedFormEventTypes.submit) {
      this.handleSubmitEvent(event);
    } else if (event.type === AdvancedFormEventTypes.validation) {
      this.handleValidationEvent(event);
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  abstract handleSubmitEvent(event: IAdvancedFormEvent): void;
  abstract handleValidationEvent(event: IAdvancedFormEvent): void;
}
